// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"df05a2f0","91":"e9e11f30","236":"3e076df8","254":"9a528b32","278":"0bdafcca","313":"12fa5f51","326":"70207f0d","510":"7da706aa","518":"3751fe4e","524":"2b835d20","606":"bfd4465a"}[chunkId] + ".chunk.js";
};